import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { InfoPersonalCliente } from './InfoPersonalCliente';

export function ModalLlamar({ cliente, mostrarModal, onCerrar }) {
    if (!mostrarModal || !cliente) return null;
  console.log('ModalLlamar renderizado con cliente:', cliente);
    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={onCerrar}
        >
            <div 
                className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header del Modal */}
                <div className="bg-gradient-to-r from-green-500 to-emerald-600 px-8 py-6 rounded-t-2xl">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="p-3 bg-white bg-opacity-20 rounded-full">
                                <PhoneIphoneIcon className="text-white" sx={{ fontSize: 32 }} />
                            </div>
                            <div>
                                <h2 className="text-2xl font-bold text-white">Información de Contacto</h2>
                                <p className="text-green-100 text-sm">Datos para realizar llamada</p>
                            </div>
                        </div>
                        <button
                            onClick={onCerrar}
                            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200"
                        >
                            <CloseIcon className="text-white" sx={{ fontSize: 24 }} />
                        </button>
                    </div>
                </div>

                {/* Contenido del Modal */}
                <div className="p-8">
                    {/* Información del Cliente */}
                    <InfoPersonalCliente cliente={cliente} />

                    {/* Números de Contacto */}
                    <div className="mb-6">
                        <div className="flex items-center gap-2 mb-3">
                            <PhoneIphoneIcon className="text-green-600" sx={{ fontSize: 20 }} />
                            <h3 className="text-lg font-bold text-gray-800">Números de Contacto</h3>
                            <span className="ml-auto px-3 py-1 bg-blue-100 text-blue-700 text-xs font-bold rounded-full">
                                {cliente.numerosContacto?.length || 1} {cliente.numerosContacto?.length === 1 ? 'número' : 'números'}
                            </span>
                        </div>
                        <div className="space-y-3">
                            {/* Lista de números */}
                            {cliente.numerosContacto && cliente.numerosContacto.length > 0 ? (
                                cliente.numerosContacto.map((numero, index) => (
                                    <div 
                                        key={index}
                                        className={`p-4 rounded-xl border ${
                                            index === 0 
                                                ? 'bg-gradient-to-r from-green-50 to-emerald-50 border-green-200' 
                                                : 'bg-gradient-to-r from-blue-50 to-cyan-50 border-blue-200'
                                        } hover:shadow-md transition-all`}
                                    >
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase mb-1 flex items-center gap-1">
                                                    {index === 0 && <span className="px-2 py-0.5 bg-green-500 text-white text-[10px] rounded-full">Principal</span>}
                                                    Celular {index + 1}
                                                </p>
                                                <p className={`text-2xl font-bold ${index === 0 ? 'text-green-600' : 'text-blue-600'}`}>
                                                    {numero}
                                                </p>
                                            </div>
                                           
                                        </div>
                                    </div>
                                ))
                            ) : (
                                // Fallback si no hay array de números
                                <div className="p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-200 hover:shadow-md transition-all">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <p className="text-xs font-semibold text-gray-500 uppercase mb-1 flex items-center gap-1">
                                                <span className="px-2 py-0.5 bg-green-500 text-white text-[10px] rounded-full">Principal</span>
                                                Celular Principal
                                            </p>
                                            <p className="text-2xl font-bold text-green-600">{cliente.celular}</p>
                                        </div>
                                      
                                    </div>
                                </div>
                            )}

                            {/* Mensaje informativo */}
                            {(!cliente.numerosContacto || cliente.numerosContacto.length === 1) && (
                                <div className="p-3 bg-gray-50 rounded-xl border border-gray-200">
                                    <p className="text-xs text-gray-500 italic text-center">
                                        * Este es el único número registrado para este cliente
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Información Adicional */}
                    <div className="p-4 bg-amber-50 rounded-xl border border-amber-200 mb-6">
                        <p className="text-xs text-amber-700">
                            <strong>⚠️ Nota:</strong> Asegúrese de verificar la identidad del cliente antes de proporcionar información sensible.
                        </p>
                    </div>

                    {/* Botón Cerrar */}
                    <div className="flex justify-end">
                        <button
                            onClick={onCerrar}
                            className="px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white font-semibold rounded-xl hover:from-gray-600 hover:to-gray-700 transition-all duration-200 shadow-md hover:shadow-lg"
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
